import React from 'react';
import { Phone, Mail, Instagram, Facebook } from 'lucide-react';
import { mockData } from '../data/mock';

const TikTokIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src={mockData.company.logo}
                alt="SIA Tīrīšana Logo"
                className="h-16 w-auto"
              />
              <span className="text-xl font-bold text-white">
                SIA "Tīrīšana"
              </span>
            </div>
            <p className="text-gray-400 mb-4">
              Profesionāla logu tīrīšana visā Latvijā. Strādājam rūpīgi un kvalitatīvi.
            </p>
            <div className="flex space-x-4">
              <a
                href={mockData.company.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-sky-500 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={mockData.company.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-sky-500 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={mockData.company.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-sky-500 rounded-lg flex items-center justify-center transition-colors"
                aria-label="TikTok"
              >
                <TikTokIcon />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Ātrās saites</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('sakums')}
                  className="text-gray-400 hover:text-sky-400 transition-colors"
                >
                  Sākums
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pakalpojumi')}
                  className="text-gray-400 hover:text-sky-400 transition-colors"
                >
                  Pakalpojumi
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('par-mums')}
                  className="text-gray-400 hover:text-sky-400 transition-colors"
                >
                  Par mums
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('atsauksmes')}
                  className="text-gray-400 hover:text-sky-400 transition-colors"
                >
                  Atsauksmes
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('kontakti')}
                  className="text-gray-400 hover:text-sky-400 transition-colors"
                >
                  Kontakti
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Kontakti</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${mockData.company.phone}`}
                  className="flex items-center space-x-3 text-gray-400 hover:text-sky-400 transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  <span>{mockData.company.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${mockData.company.email}`}
                  className="flex items-center space-x-3 text-gray-400 hover:text-sky-400 transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  <span className="text-sm break-all">{mockData.company.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} SIA "Tīrīšana". Visas tiesības aizsargātas.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
